const AVANQUEST_DOMAIN = 'wc.onenews'
const AVANQUEST_DEV_PORT = '3007'

export function isAvanquest(): boolean {
  const hostname = window?.location.hostname
  const port = window?.location.port

  return (
    hostname === 'wc.onenews.com' ||
    hostname === 'wc-staging.onenews.com' ||
    hostname?.includes(AVANQUEST_DOMAIN) ||
    (hostname === 'localhost' && port === AVANQUEST_DEV_PORT)
  )
}
